import { Button, colors, ProductLineTitle, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

const DISABLED_BACKGROUND_ALPHA = '73';

export const RenewalActionOptionStyled = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: stretch;
  gap: 1.5rem;
  padding: 1.4rem 2rem;
  box-sizing: border-box;
  background-color: ${({ $disabled }): string =>
    $disabled ? `${colors.neutral[100]}${DISABLED_BACKGROUND_ALPHA}` : colors.neutral.white};
  border-bottom: 1px solid ${colors.neutral[300]};

  &:first-child {
    border-radius: 10px 10px 0 0;
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 10px 10px;
  }

  ${breakpointsMQ4.lg.down} {
    flex-direction: column;
  }
`;

export const OptionContentStyled = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`;

export const OptionTitleStyled = styled.h3`
  ${typography.bold[16]}
  color: ${colors.neutral[900]};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const OptionDescriptionStyled = styled.p`
  ${typography.regular[16]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const StatusColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 1rem;

  ${breakpointsMQ4.lg.down} {
    align-items: flex-start;
  }
`;

export const StatusLabelStyled = styled.span<{ $disabled: boolean }>`
  ${typography.capsBold[14]}
  color: ${({ $disabled }): string => ($disabled ? colors.neutral[700] : colors.green[600])};
`;

export const DisabledReasonBlockStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  text-align: right;
`;

export const DisabledReasonTextStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.indigo[600]};
`;

export const ProductLinesBlockStyled = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.2rem;
  justify-content: flex-end;
  max-width: 32rem;

  ${breakpointsMQ4.lg.down} {
    max-width: 100%;
    justify-content: flex-start;
  }
`;

export const ProductLineTitleStyled = styled(ProductLineTitle)`
  margin: 0;
`;

export const PopoverProductLinesLabelStyled = styled.p`
  ${typography.bold[16]}
  color: ${colors.neutral[900]};
  margin: 0 0 1rem;
`;

export const MoreProductLinesButtonStyled = styled(Button)`
  min-width: unset;
  padding: 0;
  height: auto;
`;

export const ProductLinesPopoverListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ProductLinesPopoverItemStyled = styled.li`
  display: flex;
  align-items: center;
`;
